import { FloatingFormItem } from '@/components/_common';
import { Card, Col, Form, FormInstance, Input, Row, Select } from 'antd';
import { deductionTypeOptions } from './options';
import { useInvoiceFormContext } from '../../../InvoiceFormProvider';

interface Props {
  form: FormInstance;
}

const InvoiceServiceDedutionForm: React.FC<Props> = ({ form }) => {
  const { disabledFields } = useInvoiceFormContext();

  return (
    <Form form={form} preserve={false} disabled={disabledFields}>
      <Card type="inner" title="Informações de dedução">
        <Row gutter={[24, 16]}>
          <Col span={24} sm={12} lg={8}>
            <FloatingFormItem
              label="Tipo de dedução"
              name={['itemTaxes', 'dedution', 'deductionType']}
            >
              <Select options={deductionTypeOptions} allowClear />
            </FloatingFormItem>
          </Col>

          <Col span={24} sm={12} lg={16}>
            <FloatingFormItem
              label="Descrição da dedução"
              name={['itemTaxes', 'dedution', 'deductionDescription']}
            >
              <Input />
            </FloatingFormItem>
          </Col>
        </Row>
      </Card>
    </Form>
  );
};

export default InvoiceServiceDedutionForm;
